import React, { Component } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import './shards.css';
import { Redirect } from 'react-router';
import fire from './fire';

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';


import {card} from './card';

const database = fire.database();

const sessions = database.ref('sessions');



export let firstUserKey;




export default class Main extends React.Component {

    constructor(props) {
    super(props);

   
    

    this.state = { 
      src: "1.jpg",
      cardNumber: 0,
      cardTitle: "LELO Tiani 3",
      cardsClickedArray: [],
      buyLink: "https://www.amazon.com/gp/product/B00GM0DXU6/ref=s9_acss_bw_cg_SSGGCOUP_4c1_w?pf_rd_m=ATVPDKIKX0DER&pf_rd_s=merchandised-search-3&pf_rd_r=0ER4TBH50VPR3N8TS1PK&pf_rd_t=101&pf_rd_p=7af2b587-c7bd-42ed-ae4a-42fc501daa29&pf_rd_i=6110399011&th=1",
      description:"For thrill-seeking couples looking for an entirely new way to enjoy sex, TIANI 3 offers powerful, intimate pleasure and guaranteed satisfaction.",
      redirect: false
      

    };

    this.handleClickLiked = this.handleClickLiked.bind(this);
    this.handleClickDisliked = this.handleClickDisliked.bind(this);

  }

  

  handleClickLiked(newCard) {

    let cardNumber = this.state.cardNumber;
    let cardsClickedArray = this.state.cardsClickedArray;
    let thisCard = newCard[cardNumber];
    thisCard.likedOne = true;
    cardsClickedArray.push(thisCard);

    if (cardNumber + 1 < newCard.length) {


    


    // calling handleClick will 
    // result in a state change:
      this.setState(
        { 
          src: newCard[cardNumber + 1].src,
          cardTitle: newCard[cardNumber + 1].title,
          buyLink: newCard[cardNumber + 1].buyLink,
          description: newCard[cardNumber + 1].description,
          cardsClickedArray: cardsClickedArray,
          cardNumber: cardNumber + 1
        }
      );

    } else {

        firstUserKey = sessions.push(cardsClickedArray).key;

        console.log(firstUserKey);
      
        this.setState({redirect: true});
     
    }

    console.log(cardsClickedArray);
    console.log('you like this card');
    
    
  }

  handleClickDisliked(newCard) {
    let cardNumber = this.state.cardNumber;
    let cardsClickedArray = this.state.cardsClickedArray;
    let thisCard = newCard[cardNumber];
    cardsClickedArray.push(thisCard);

    if (cardNumber + 1 < newCard.length) {
    


    // calling handleClick will 
      // result in a state change:
      this.setState(
        { 
          src: newCard[cardNumber + 1].src,
          cardTitle: newCard[cardNumber + 1].title,
          buyLink: newCard[cardNumber + 1].buyLink,
          description: newCard[cardNumber + 1].description,
          cardsClickedArray: cardsClickedArray,
          cardNumber: cardNumber + 1
        }
      );
    } else {
        
        firstUserKey = sessions.push(cardsClickedArray).key;

        console.log(firstUserKey);
      
        this.setState({redirect: true});
    }
    console.log(cardsClickedArray);
    console.log('you dislike this card');
    
    
  }

 

  
  render() {

    if (this.state.redirect) {
    return <Redirect push to={{
      pathname: "/donemain/"+firstUserKey 
    }} />
  }

    return(<main role="main" className="container main" style={{paddingTop: 100}}>
      <div className="row justify-content-center">
        <div className="col-sm-12 col-md-6 col-lg-4" style={{marginTop: 15, marginBottom: 15}}>
            <div className="card">
              <h4 className="card-title text-muted" style={{marginBottom:"-20px", zIndex:'99', marginTop:10, marginRight:10, marginLeft:10, opacity:"0.8"}}><span className="float-right"><ModalExample description={this.state.description} buyLink={this.state.buyLink} cardTitle={this.state.cardTitle}/></span></h4>
              <img id="image" className="card-img-top" src={this.state.src} onClick={this.changeImage} alt="Card image cap" />
              <div className="card-body">

                <p className="card-title text-muted small" style={{opacity:"0.7", marginTop:-40, marginBottom:0}}>{this.state.cardNumber + 1}/13</p>
                <p className="card-title lead">{this.state.cardTitle}</p>
                
                <LikedButton onClick={this.handleClickLiked} />
                
                <DislikedButton onClick={this.handleClickDisliked} />

                
              </div>
            </div>
            </div>
      </div>
      </main>)}
}


export class LikedButton extends React.Component {
  constructor(props) {
    super(props);
    
    this.handleClickLiked = this.handleClickLiked.bind(this);
  }

  handleClickLiked() {
   

    this.props.onClick(card);
  }

  render() {
    return(
      <div onClick={this.handleClickLiked} style={{borderRadius:"50%", marginLeft:50}} className="btn btn-lg btn-outline-success float-left"><i className="fa fa-heart" aria-hidden="true"></i></div>

      );
  }
}

export class DislikedButton extends React.Component {
  constructor(props) {
    super(props);
    
    this.handleClickDisliked = this.handleClickDisliked.bind(this);
  }

  handleClickDisliked() {
   

    this.props.onClick(card);
  }

  render() {
    return(
      <div onClick={this.handleClickDisliked} style={{borderRadius:"50%", marginRight:50}} className="btn btn-lg btn-outline-danger float-right"><i className="fa fa-thumbs-down" aria-hidden="true"></i></div>

      );
  }
}










class ModalExample extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  render() {
    return (
      <div>
        <Button color="link" size="lg" onClick={this.toggle}><i className="fa fa-info-circle" aria-hidden="true"></i></Button>
        <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
          <ModalHeader toggle={this.toggle}>{this.props.cardTitle}</ModalHeader>
          <ModalBody>
            {this.props.description}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" href={this.props.buyLink}>Buy</Button>{' '}
            <Button color="secondary" onClick={this.toggle}>Close</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Main.js